module.exports = __webpack_public_path__ + "static/cover-background.ea27d305.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/cover-background.jpg
// module id = 229
// module chunks = 0